import { createContext, useContext, useMemo } from 'react';
import { gate } from 'hub-http/gates';
import UserInfoProvider from '../UserInfoProvider';
import { UserInfoContext } from 'reporting-data/userInfo/userInfoContext';
import { jsx as _jsx } from "react/jsx-runtime";
const CrmObjectTableReportComponentContext = /*#__PURE__*/createContext(null);
const useIsUngatedForCrmObjectTableInReports = () => {
  const userInfo = useContext(UserInfoContext);
  return useMemo(() => userInfo.gates.includes(gate('CRM:Grid:CrmObjectTableInReports')), [userInfo.gates]);
};
const ProvideCrmObjectTableReportComponentInner = ({
  children,
  component
}) => {
  const isUngated = useIsUngatedForCrmObjectTableInReports();
  if (!isUngated) {
    return children;
  }
  return /*#__PURE__*/_jsx(CrmObjectTableReportComponentContext.Provider, {
    value: component,
    children: children
  });
};
export const ProvideCrmObjectTableReportComponent = ({
  children,
  component
}) => {
  return /*#__PURE__*/_jsx(UserInfoProvider, {
    children: /*#__PURE__*/_jsx(ProvideCrmObjectTableReportComponentInner, {
      component: component,
      children: children
    })
  });
};
export const useCrmObjectTableReportComponent = () => {
  const context = useContext(CrmObjectTableReportComponentContext);
  return context;
};